import React from "react";
import "../../TrainingPages.css";
import { Row } from "react-bootstrap";
import { Link } from "react-router-dom";

function HomeButton() {
    /**
     * Component for the back to home button at the top of the splash page.
     * @returns: home button JSX component
     */
    return (
        <Row className="justify-content-center text-center"> 
            <div className="d-flex w-100 justify-content-center align-items-center flex-wrap"> 
                <div className="col-lg justify-content-center align-items-center py-1 px-2"> 
                    <Link className="btn light-button-sport" to="/" role="button">Back to Homepage</Link> 
                </div> 
            </div> 
        </Row> 
    );
}

export default HomeButton;